import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import React, { Component } from 'react';
import { Control, LocalForm, Errors } from 'react-redux-form';
import PropTypes from 'prop-types';
import Header from '../Header';
import { Helmet } from 'react-helmet';
import Footer from '../Footer';
import './assesment.css';
import MyUploader from '../../elements/Upload'
import {Link} from "react-router-dom";
import FilesTable from './table';
import ModalExample from "../../elements/PopupWindow";
import {config} from "../../../utility/swaggerClient";

let messages=defineMessages({
    htmlHeader: {
      id: 'preview.html.headerAna',
      description:
        'The title of the page that appears in the html header of the page.',
      defaultMessage: 'Assessment'
    },
    headerTitle: {
      id: 'assessment.header.title',
      description: 'Page Header Title',
      defaultMessage: 'Analyzer Report'
    },
    headerSubTitle: {
      id: 'assessment.header.subtitle',
      description: 'Page Header Subtitle',
      defaultMessage: 'Finalize project details to generate your Analyzer Report'
    },
    searchFiles: {
      id: 'preview.search.files',
      description: 'search files',
      defaultMessage: 'Search Files'
    },
    alertTitle: {
      id: 'preview.alert.title',
      description: 'Preview API alert title',
      defaultMessage: 'Loading Project Files Failed'
    }
  });

let checkfreemsg = "A free FUSE Analyzer Report has already been requested by another member of your organization.";
let NPfreeuploadType = "";

class CreateDataFactoryProject extends Component{
    componentDidMount() {
        console.log(this.props.userType);
        console.log(this.props.role);
        const jobType = this.props.userType === "standard" ? "Assessment" : "FreeAssessment";
        NPfreeuploadType = this.props.userType === "standard" ? "internal_assessment" : "internal_FreeAssessment";
        this.props.resetCustomersPrjList();
        this.props.resetStagingPrjList();
        if(this.props.role.includes('TRANSLATION_LEAD') || this.props.role.includes('DATA_ENGINEER')){
          this.props.getCustomers();
        }else{
          if(this.props.userType === "free"){
            this.setState({validfree : false});
            // this.props.checkfree(this.props.username,this.checkfreeCallback);
            const requestOptions = {
              method: 'GET',
              headers: { 'Content-Type': 'application/json',"Authorization": sessionStorage.getItem('jwt') },
            };
            fetch(`${config.protocol}://${config.host}/api/user/assessment/checkFree`, requestOptions)
              .then(data => {
                console.log(data)
                if(data.status === 200){
                  this.setState({validfree : true});
                }else if(data.status === 402){
                  // data.status === 200
                  checkfreemsg = "Your free FUSE Analyzer Report is only eligible for once every 12 months."
                }
              });
    
          }
          this.props.gitlabProjects(jobType,this.props.customerid);
        }
        messages = this.props.userType === "standard" ?
          defineMessages({
            htmlHeader: {
              id: 'preview.html.headerAna',
              description:
                'The title of the page that appears in the html header of the page.',
              defaultMessage: 'Assessment'
            },
            headerTitle: {
              id: 'assessment.header.title',
              description: 'Page Header Title',
              defaultMessage: 'Analyzer Report'
            },
            headerSubTitle: {
              id: 'assessment.header.subtitle',
              description: 'Page Header Subtitle',
              defaultMessage: 'Finalize project details to generate your Analyzer Report'
            },
            searchFiles: {
              id: 'preview.search.files',
              description: 'search files',
              defaultMessage: 'Search Files'
            },
            alertTitle: {
              id: 'preview.alert.title',
              description: 'Preview API alert title',
              defaultMessage: 'Loading Project Files Failed'
            }
          }) :
          defineMessages({
            htmlHeader: {
              id: 'preview.html.headerAna',
              description:
                'The title of the page that appears in the html header of the page.',
              defaultMessage: 'Assessment'
            },
            headerTitle: {
              id: 'freeassessment.header.title',
              description: 'Page Header Title',
              defaultMessage: 'Free Analyzer Report'
            },
            headerSubTitle: {
              id: 'freeassessment.header.subtitle',
              description: 'Page Header Subtitle',
              defaultMessage: 'Finalize project details to generate your Free FUSE Analyzer Report'
            },
            searchFiles: {
              id: 'preview.search.files',
              description: 'search files',
              defaultMessage: 'Search Files'
            },
            alertTitle: {
              id: 'preview.alert.title',
              description: 'Preview API alert title',
              defaultMessage: 'Loading Project Files Failed'
            }
          });
      }

      checkuploadinlist = (prj,type)=>{
        const jobType = this.props.userType === "standard" ? "Assessment" : "FreeAssessment";
        console.log(type);
        if(type !== 'internal_assessment' && type !== 'internal_translation' && type !== 'internal_FreeAssessment'){
          this.props.gitlabProjects(jobType,this.props.customerid);
          // if(this.props.customerprojectList.includes(prj)){
            this.setState({repo : prj})
          // }
          // return this.props.customerprojectList.includes(prj);
          return true;
        }else{
          this.props.getStagingPrjList(jobType,this.state.repo,this.state.customer);
          // if(this.props.stagingprojectList.includes(prj)){
            this.setState({stagingrepo : prj});
          // }
          // return this.props.stagingprojectList.includes(prj);
          return true;
        }
      }

      constructor(props) {
        super(props);
        const { intl } = this.props;
        this.state = {
          show: false,
          showUpload: false,
          projectName: "",
          targetLanguage: "",
          srclang:"",
          description:"",
          customer: "",
          showFiles: false,
          stagingrepo: "",
          repo: "",
          showMessage: false,
          refId: "",
          uploadType:"",
          uploadcontent:"",
          validfree: true,
          disableUploadBack: false,
          disableupload: false
        };
      }

      setDisableupload = (val)=>{
        this.setState({disableupload : val})
      }
    
      setPrjName = (name)=>{
        this.setState({projectName : name});
      }
    
      setDisableUploadBack = (val)=>{
        this.setState({disableUploadBack : val});
      }
    
      setUploadcontent = (s)=>{
        this.setState({uploadcontent:s});
      }

      showUploadTrue = (type) => {
        messages.headerSubTitle.id = type;
        if(type === "upload"){
          this.setState({ showUpload: true,  uploadType: type, projectName : ""});
        }else{
          this.setState({ showUpload: true,  uploadType: type, projectName : this.state.repo});
        }
      };
    
      showMessageTrue = (e) => {
        this.setState({ showMessage: true, refId :  e.value.data});
      };
    
      showNPupload =(type)=>{
        messages.headerSubTitle.id = type;
        const prj = type === 'upload' ? this.state.repo + "_" + Date.now() : this.state.stagingrepo;
        this.setState({ showUpload: true,  uploadType: type, projectName : prj});
      }
    
      showNPuploadFlase =()=>{
        const jobType = this.props.userType === "standard" ? "Assessment" : "FreeAssessment";
        this.props.getStagingPrjList(jobType,this.state.repo,this.state.customer);
        this.setState({ showUpload: false });
        this.setDisableupload(false);
        messages = this.props.userType === "standard" ?
          defineMessages({
            htmlHeader: {
              id: 'preview.html.headerAna',
              description:
                'The title of the page that appears in the html header of the page.',
              defaultMessage: 'Assessment'
            },
            headerTitle: {
              id: 'assessment.header.title',
              description: 'Page Header Title',
              defaultMessage: 'Analyzer Report'
            },
            headerSubTitle: {
              id: 'assessment.header.subtitle',
              description: 'Page Header Subtitle',
              defaultMessage: 'Finalize project details to generate your Analyzer Report'
            },
            searchFiles: {
              id: 'preview.search.files',
              description: 'search files',
              defaultMessage: 'Search Files'
            },
            alertTitle: {
              id: 'preview.alert.title',
              description: 'Preview API alert title',
              defaultMessage: 'Loading Project Files Failed'
            }
          }) :
          defineMessages({
            htmlHeader: {
              id: 'preview.html.headerAna',
              description:
                'The title of the page that appears in the html header of the page.',
              defaultMessage: 'Assessment'
            },
            headerTitle: {
              id: 'freeassessment.header.title',
              description: 'Page Header Title',
              defaultMessage: 'Free Analyzer Report'
            },
            headerSubTitle: {
              id: 'freeassessment.header.subtitle',
              description: 'Page Header Subtitle',
              defaultMessage: 'Finalize project details to generate your Free FUSE Analyzer Report'
            },
            searchFiles: {
              id: 'preview.search.files',
              description: 'search files',
              defaultMessage: 'Search Files'
            },
            alertTitle: {
              id: 'preview.alert.title',
              description: 'Preview API alert title',
              defaultMessage: 'Loading Project Files Failed'
            }
          });
      }
    
      showUploadFalse = () => {
        const jobType = this.props.userType === "standard" ? "Assessment" : "FreeAssessment";
        this.props.gitlabProjects(jobType,this.props.customerid);
        this.setState({ showUpload: false });
        this.setDisableupload(false);
        messages = this.props.userType === "standard" ?
          defineMessages({
            htmlHeader: {
              id: 'preview.html.headerAna',
              description:
                'The title of the page that appears in the html header of the page.',
              defaultMessage: 'Assessment'
            },
            headerTitle: {
              id: 'assessment.header.title',
              description: 'Page Header Title',
              defaultMessage: 'Analyzer Report'
            },
            headerSubTitle: {
              id: 'assessment.header.subtitle',
              description: 'Page Header Subtitle',
              defaultMessage: 'Finalize project details to generate your Analyzer Report'
            },
            searchFiles: {
              id: 'preview.search.files',
              description: 'search files',
              defaultMessage: 'Search Files'
            },
            alertTitle: {
              id: 'preview.alert.title',
              description: 'Preview API alert title',
              defaultMessage: 'Loading Project Files Failed'
            }
          }) :
          defineMessages({
            htmlHeader: {
              id: 'preview.html.headerAna',
              description:
                'The title of the page that appears in the html header of the page.',
              defaultMessage: 'Assessment'
            },
            headerTitle: {
              id: 'freeassessment.header.title',
              description: 'Page Header Title',
              defaultMessage: 'Free Analyzer Report'
            },
            headerSubTitle: {
              id: 'freeassessment.header.subtitle',
              description: 'Page Header Subtitle',
              defaultMessage: 'Finalize project details to generate your Free FUSE Analyzer Report'
            },
            searchFiles: {
              id: 'preview.search.files',
              description: 'search files',
              defaultMessage: 'Search Files'
            },
            alertTitle: {
              id: 'preview.alert.title',
              description: 'Preview API alert title',
              defaultMessage: 'Loading Project Files Failed'
            }
          });
      };
    
      changeRepo = (e)=>{
        const jobType = this.props.userType === "standard" ? "Assessment" : "FreeAssessment";
        this.setState({repo: e.target.value});
        this.props.getinfobyreponameforaccessment(e.target.value,this.props.customerid,jobType,this.updateSrcTar);
      }
    
      getFilesList = ()=>{
        this.setState({showFiles : true});
        this.props.getfilesList(this.state.repo,this.props.customerid);
      }
    
      selectCus = (e)=>{
        this.props.resetStagingPrjList();
        const jobType = this.props.userType === "standard" ? "Assessment" : "FreeAssessment";
        this.setState({customer : e.target.value});
        this.props.customersPrjList(jobType,e.target.value);
      }
    
      confirmation = ()=>{}
      confirmationSubmit = ()=>{
        const jobType = this.props.userType === "standard" ? "Assessment" : "FreeAssessment";
        this.props.userRequest(
          this.props.username,
          this.state.repo,
          this.state.srclang,
          this.state.targetLanguage,
          this.state.description,
          jobType,
          this.props.customerid,
          this.showMessageTrue
        );
      }
      confirmationText = this.props.userType === "standard" ?
        "Please make sure you have uploaded all the required files before proceeding with this charged analysis.   <br /><br />" +
        "Note: you will receive 1,000 lines of sample translated code if you upload your legacy code package which contains the sample legacy code in a file named Sample_RedShift_Translation. <br /><br />" +
        "Multiple runs will result in additional costs to your organization.<br /><br />" +
        " Select BACK to make further changes or SUBMIT to proceed.<br />"
        :
        "Please make sure you have uploaded all the required files before submitting for the Report for processing.  <br /><br />" +
        "Note: you will receive 1,000 lines of sample translated code if you upload your legacy code package which contains the sample legacy code in a file named Sample_RedShift_Translation. <br /><br />" +
        "Your free FUSE Analyzer Report is only eligible for once every 12 months.<br /><br />" +
        " Select BACK to make further changes or SUBMIT to proceed.<br />"
    
      submitRequest = ()=>{
        this.confirmation();
      }
    
      getStagingRepo = (jobtype,repo)=>{
        const jobType = this.props.userType === "standard" ? "Assessment" : "FreeAssessment";
        this.setState({stagingrepo : ""});
        this.setState({repo : repo});
        this.props.getinfobyreponameforaccessment(repo,this.state.customer,jobType,this.updateSrcTar);
        this.props.getStagingPrjList(jobType,repo,this.state.customer);
      }
    
      updateSrcTar = (e)=>{
        console.log(e)
        this.setState({targetLanguage : e.value.data.tgtlang , srclang: e.value.data.srclang, description: e.value.data.description});
      }
    
      gotoFileList = ()=>{
        if(this.state.srclang !== "" && this.state.targetLanguage !== "" && this.state.repo !== ""
          && this.state.srclang !== null && this.state.targetLanguage !== null && this.state.repo !== null
        ){
          this.getFilesList();
        }
      }

      render() {


        const jobType = this.props.userType === "standard" ? "Assessment" : "FreeAssessment";
    
        if(this.props.role.includes('TRANSLATION_LEAD') || this.props.role.includes('DATA_ENGINEER')){
          return (
            <div className={this.state.show ? 'pageHide' : 'page'}>
              <Helmet>
                <title>
                  {this.props.intl.formatMessage(messages.htmlHeader)} - FUSE
                </title>
              </Helmet>
              <Header
                title={this.props.intl.formatMessage(messages.headerTitle)}
                subtitle={this.props.intl.formatMessage(messages.headerSubTitle)}
                icon="preview"
                locale={this.props.locale}
                status = {this.props.status}
              />
    
              <div className="main">
                <div
                  className="panel"
                  style={{
                    width: '60%',
                    padding: '40px',
                    boxSizing: 'content-box',
                    marginTop: '15px',
                    display: 'block',
                    alignContent: 'center',
                    marginLeft: 'auto',
                    marginRight: 'auto'
                  }}
                >
    
                  {!this.state.showMessage && (
                    <div>
                      {this.state.showUpload ? (
                        <div className="form">
                          <label style={{ textTransform: 'capitalize' }}>
                            <FormattedMessage
                              id="source.code.project.name"
                              defaultMessage="Project Name"
                            />
                          </label>
                          <Control.text
                            model=".projectName"
                            value={this.state.projectName}
                            placeholder={this.state.uploadType==='upload' ?"same as zip file name" : ""}
                            disabled
                          />
    
                          <br />
                          <br />
                          <br />
                          {MyUploader(this.state.projectName,this.props.username,this.state.uploadType,
                            NPfreeuploadType,this.state.repo,this.state.customer,this.state.uploadcontent,this.setUploadcontent,
                            this.setDisableUploadBack,this.setPrjName,this.checkuploadinlist,this.state.disableUploadBack,
                            this.state.disableupload,this.setDisableupload
                          )}
                          <br />
                          <br />
                          <br />
    
                          <button
                            className="button"
                            type="button"
                            style={{ marginRight: '40px' }}
                            onClick={this.showNPuploadFlase}
                            disabled={this.state.disableUploadBack}
                          >
                            back
                          </button>
                        </div>
                      ) : null}
    
                      {!this.state.showUpload && (
                        <LocalForm
                          className="form"
                          onSubmit={() =>
                            this.props.clickSubmitHandler(
                              this.props.username,
                              this.state.repo,
                              this.state.srclang,
                              this.state.targetLanguage,
                              this.state.description,
                              jobType,
                              this.state.stagingrepo,
                              this.state.customer,
                              this.state.repo,
                              this.showMessageTrue,
                            )
                          }
                        >
                          <div
                            style={{
                              marginLeft: '3%'
                            }}
                          >
                            <fieldset>
                              <label style={{ textTransform: 'capitalize' }}>
                                <FormattedMessage
                                  id="onboard.organization"
                                  defaultMessage="Organization Name: "
                                />
                              </label>
    
                              <Control.select
                                model=".customer"
                                autoFocus
                                required
                                defaultValue={this.state.customer}
                                onChange={this.selectCus}
                              >
                                {(this.state.customer === "" || this.state.customer === null) && <option value="">Please select organization name</option>}
                                {this.props.customersList.map(item => (
                                  <option key={item["customer_id"]} value={item["customer_id"]}>
                                    {item["company_name"]}
                                  </option>
                                ))}
                              </Control.select>
    
                            </fieldset>
    
                            <fieldset>
                              <label style={{ textTransform: 'capitalize' }}>
                                <FormattedMessage
                                  id="source.code.project.name"
                                  defaultMessage="Source Code Repository Name: "
                                />
                              </label>
    
                              <Control.select
                                model=".reponame"
                                autoFocus
                                required
                                defaultValue={this.state.repo}
                                onChange={(e)=>{this.getStagingRepo(jobType,e.target.value);}}
                              >
                                {(this.state.repo === "" || this.state.repo === null) && <option value="">Please select project name</option>}
                                {this.props.customerprojectList.map((item,index) => (
                                  <option key={index} value={item}>
                                    {item}
                                  </option>
                                ))}
                              </Control.select>
                            </fieldset>
    
                            <fieldset>
                              <label style={{ textTransform: 'capitalize' }}>
                                <FormattedMessage
                                  id="assessment.stagingname"
                                  defaultMessage="Source Code Staging Project Name:"
                                />
                              </label>
    
                              <Control.select
                                model=".staging"
                                autoFocus
                                required
                                value={this.state.stagingrepo}
                                onChange={(e) => (this.setState({stagingrepo: e.target.value}))}
                              >
                                {(this.state.stagingrepo === "" || this.state.stagingrepo === null) && <option value="">Please select staging project name</option>}
                                {this.props.stagingprojectList.map(item => (
                                  <option key={item} value={item}>
                                    {item}
                                  </option>
                                ))}
                              </Control.select>
                              <button
                                className="button asse_upload"
                                type="button"
                                onClick={()=> this.showNPupload("update")}
                                disabled={this.state.stagingrepo === ""}
                              >
                                Update source code
                              </button>
                            </fieldset>
    
                            <fieldset>
                              <label style={{ textTransform: 'capitalize' }}>
                                <FormattedMessage
                                  id="projects.project.source-languagee"
                                  defaultMessage="Source Language: "
                                />
                              </label>
    
                              <Control.text
                                model=".srclang"
                                value={this.state.srclang}
                                required
                                disabled
                              >
                              </Control.text>
    
                            </fieldset>
    
                            <fieldset>
                              <label style={{ textTransform: 'capitalize' }}>
                                <FormattedMessage
                                  id="projects.project.target-language"
                                  defaultMessage="Target Language: "
                                />
                              </label>
    
                              <Control.text
                                model=".tgtlang"
                                value={this.state.targetLanguage}
                                required
                                disabled
                              >
                              </Control.text>
                            </fieldset>
    
                            <fieldset>
                              <label style={{ textTransform: 'capitalize' }}>
                                <FormattedMessage
                                  id="comments.name"
                                  defaultMessage="Description"
                                />
                              </label>
    
                              <Control.text
                                model=".description"
                                value={this.state.description}
                                disabled
                              />
                            </fieldset>
    
                            <div
                              className="button-container"
                              style={{ textAlign: 'center' }}
                            >
                              <button
                                className="button"
                                type="button"
                                style={{ marginRight: '40px' }}
                                onClick={() => this.props.clickBackHandler()}
                              >
                                <FormattedMessage
                                  id="run-assessment.back.button.name"
                                  defaultMessage="Back"
                                />
                              </button>
    
                              <button
                                className="button"
                                type="button"
                                onClick={()=>this.showNPupload("upload")}
                                style={{ marginRight: '40px' }}
                                disabled={this.state.repo === ""}
                              >
                                Upload source code
                              </button>
    
                              <button
                                className="button"
                                type="submit"
                              >
                                <FormattedMessage
                                  id="submit.button.name"
                                  defaultMessage="submit"
                                />
                              </button>
                            </div>
                          </div>
                        </LocalForm>
                      )}
                    </div>
                  )}
    
                  {this.state.showMessage && (
                    <div className="form">
                      <label
                        style={{
                          width: '90%',
                          fontSize: '16px',
                          textTransform: 'none',
                          lineHeight: '150%'
                        }}
                      >
                        Your {this.props.userType === "standard" ? '' : 'free '} FUSE Analyzer Report request has been submitted.  The Report’s reference ID is  {this.state.refId}.  You will be notified via email once the FUSE Analyzer Report is generated.
    
                      </label>
                      <br />
                      &nbsp;
                      <br />
                      &nbsp;
                      <div className="button-container" style={{ textAlign: 'center' }}>
                        <button
                          className="button"
                          styel={{ padding: 20 }}
                          type="button"
                          onClick={this.props.clickBackHandler}
                        >
                          <FormattedMessage id="nav.ok" defaultMessage="OK" />
                        </button>
                      </div>
                    </div>
                  )}
    
                </div>
              </div>
              <Footer />
            </div>
          );
        }
        else{
          return (
            <div className="page">
              <Helmet>
                <title>
                  {this.props.intl.formatMessage(messages.htmlHeader)} - FUSE
                </title>
              </Helmet>
              <Header
                title={this.props.intl.formatMessage(messages.headerTitle)}
                subtitle={this.props.intl.formatMessage(messages.headerSubTitle)}
                icon="preview"
                locale={this.props.locale}
                status = {this.props.status}
              />
              <ModalExample
                hasTitle
                confirmation
                infoText="Confirmation"
                className="modal_lg"
                setClick={click => this.confirmation = click}
                confirmationSub = {this.confirmationSubmit}
                content={this.confirmationText}/>
              <div className="main">
                <div
                  className="panel"
                  style={{
                    width: '60%',
                    padding: '40px',
                    boxSizing: 'content-box',
                    marginTop: '15px',
                    display: 'block',
                    alignContent: 'center',
                    marginLeft: 'auto',
                    marginRight: 'auto'
                  }}
                >
                  {!this.state.showMessage && (
                    <div>
                      {this.state.validfree && (
                        <div>
                          {this.state.showUpload ? (
                            <div className="form">
                              <label style={{ textTransform: 'capitalize' }}>
                                <FormattedMessage
                                  id="source.code.project.name"
                                  defaultMessage="Project Name"
                                />
                              </label>
                              <Control.text
                                model=".projectName"
                                autoFocus
                                value={this.state.projectName}
                                placeholder={this.state.uploadType==='upload' ?"same as zip file name" : ""}
                                disabled
                              />
    
                              <br />
                              <br />
                              <br />
                              {MyUploader(this.state.projectName,this.props.username,
                                this.state.uploadType,jobType,"",
                                this.props.customerid,this.state.uploadcontent,this.setUploadcontent,this.setDisableUploadBack,this.setPrjName,
                                this.checkuploadinlist,this.state.disableUploadBack,this.state.disableupload,this.setDisableupload)}
                              <br />
                              <br />
                              <br />
    
                              <button
                                className="button"
                                type="button"
                                style={{ marginRight: '40px' }}
                                onClick={this.showUploadFalse}
                                disabled={this.state.disableUploadBack}
                              >
                                back
                              </button>
                            </div>
                          ) : null}
    
                          {(!this.state.showUpload && !this.state.showFiles) ? (
                            <LocalForm
                              className="form"
                              onSubmit={this.gotoFileList}
                            >
                              <div
                                style={{
                                  marginLeft: '3%'
                                }}
                              >
                                <fieldset>
                                  <label style={{ textTransform: 'capitalize' }}>
                                    <FormattedMessage
                                      id="source.code.project.name"
                                      defaultMessage="Source Code Repository Name: "
                                    />
                                  </label>
    
                                  <Control.select
                                    model=".reponame"
                                    required
                                    defaultValue={this.state.repo}
                                    onChange={this.changeRepo}
                                  >
                                    {(this.state.repo === "" || this.state.repo === null) && <option value="">Please select project name</option>}
                                    {this.props.customerprojectList.map((item,index) => (
                                      <option key={index} value={item}>
                                        {item}
                                      </option>
                                    ))}
                                  </Control.select>
                                  <button
                                    className="button asse_upload"
                                    type="button"
                                    onClick={()=>this.showUploadTrue("update")}
                                    disabled={this.state.repo === ""}
                                  >
                                    Update source code
                                  </button>
                                </fieldset>
    
    
                                <fieldset>
                                  <label style={{ textTransform: 'capitalize' }}>
                                    <FormattedMessage
                                      id="projects.project.source-languagee"
                                      defaultMessage="Source Language: "
                                    />
                                  </label>
    
                                  <Control.select
                                    model=".srclang"
                                    autoFocus
                                    value={this.state.srclang}
                                    onChange={(e)=>this.setState({srclang : e.target.value})}
                                    required
                                  >
                                    {(this.state.srclang === "" || this.state.srclang === null)  && <option value="">Please select source language</option>}
                                    <option value="teradata">Teradata</option>
                                  </Control.select>
    
                                </fieldset>
    
                                <fieldset>
                                  <label style={{ textTransform: 'capitalize' }}>
                                    <FormattedMessage
                                      id="projects.project.target-language"
                                      defaultMessage="Target Language: "
                                    />
                                  </label>
    
                                  <Control.select
                                    model=".tgtlang"
                                    autoFocus
                                    value={this.state.targetLanguage}
                                    onChange={(event)=>{this.setState({ targetLanguage: event.target.value});}}
                                    required
                                  >
                                    {(this.state.targetLanguage === "" || this.state.targetLanguage === null) && <option value="">Please select target language</option>}
                                    <option value="RedShift">RedShift</option>
                                  </Control.select>
                                </fieldset>
    
                                <fieldset>
                                  <label style={{ textTransform: 'capitalize' }}>
                                    <FormattedMessage
                                      id="comments.name"
                                      defaultMessage="Description"
                                    />
                                  </label>
                                  <Control.text
                                    model=".description"
                                    value={this.state.description}
                                    onChange={e => this.setState({description : e.target.value})}
                                  />
                                </fieldset>
    
                                <div
                                  className="button-container"
                                  style={{ textAlign: 'center' }}
                                >
                                  <button
                                    className="button"
                                    type="button"
                                    style={{ marginRight: '40px' }}
                                    onClick={() => this.props.clickBackHandler()}
                                  >
                                    <FormattedMessage
                                      id="run-assessment.back.button.name"
                                      defaultMessage="Back"
                                    />
                                  </button>
    
                                  <button
                                    className="button"
                                    type="button"
                                    style={{ marginRight: '40px' }}
                                    onClick={()=>this.showUploadTrue("upload")}
                                  >
                                    Upload source code
                                  </button>
    
                                  <button
                                    className="button"
                                    type="submit"
                                    onClick={this.gotoFileList}
                                  >
                                    <FormattedMessage
                                      id="onboard.next"
                                      defaultMessage="next"
                                    />
                                  </button>
                                </div>
                              </div>
                            </LocalForm>
                          ) : null}
    
                          {(!this.state.showUpload && this.state.showFiles) && (
                            <div className="form">
                              <label
                                style={{
                                  width: '90%',
                                  fontSize: '16px',
                                  textTransform: 'none',
                                  lineHeight: '150%',
                                  textAlign: 'center'
                                }}
                              >
                                Here is a list of files in your project. Please review before you click the Submit button.
                              </label>
                              <FilesTable
                                data={this.props.filesList}
                                deleteUser={this.props.deleteUser}
                                username={this.props.username}>
                              </FilesTable>
    
                              <div
                                className="button-container"
                                style={{ textAlign: 'center' }}
                              >
                                <button
                                  className="button"
                                  type="button"
                                  style={{ marginRight: '40px' }}
                                  onClick={() => this.setState({showFiles : false})}
                                >
                                  <FormattedMessage
                                    id="run-assessment.back.button.name"
                                    defaultMessage="Back"
                                  />
                                </button>
    
                                <button
                                  className="button"
                                  type="button"
                                  onClick={this.submitRequest}
                                >
                                  <FormattedMessage
                                    id="submit.button.name"
                                    defaultMessage="Submit"
                                  />
                                </button>
                              </div>
                            </div>
                          )}
                        </div>
                      )}
    
                      {!this.state.validfree && (
                        <div className="form">
                          <label
                            style={{
                              width: '90%',
                              fontSize: '16px',
                              textTransform: 'none',
                              lineHeight: '150%'
                            }}
                          >
                            {checkfreemsg} To run a Report, please select
    
                            the FUSE Analyzer Report option from the {' '}
                            <Link to="/"><i style={{textDecoration: "underline", color: "blue"}}>Home</i></Link> {' '}
                            page, or contact Next Pathway at {' '}
                            <i style={{textDecoration: "underline", color: "blue"}}
                               href="mailto:shift_support.aws@nextpathway.com">
                              shift_support.aws@nextpathway.com
                            </i>
                          </label>
                          <br />
                          &nbsp;
                          <br />
                          &nbsp;
                          <div className="button-container" style={{ textAlign: 'center' }}>
                            <button
                              className="button"
                              styel={{ padding: 20 }}
                              type="button"
                              onClick={this.props.clickBackHandler}
                            >
                              <FormattedMessage id="nav.ok" defaultMessage="OK" />
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
    
                  {this.state.showMessage && (
                    <div className="form">
                      <label
                        style={{
                          width: '90%',
                          fontSize: '16px',
                          textTransform: 'none',
                          lineHeight: '150%'
                        }}
                      >
                        Your {this.props.userType === "standard" ? '' : 'free '} FUSE Analyzer Report request has been submitted for review and will be sent to your Administrator for approval. The Report’s reference ID is {this.state.refId}.  You will be notified via email whether your request is approved.
    
                      </label>
                      <br />
                      &nbsp;
                      <br />
                      &nbsp;
                      <div className="button-container" style={{ textAlign: 'center' }}>
                        <button
                          className="button"
                          styel={{ padding: 20 }}
                          type="button"
                          onClick={this.props.clickBackHandler}
                        >
                          <FormattedMessage id="nav.ok" defaultMessage="OK" />
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <Footer />
            </div>
          );
        }
      }
}

CreateDataFactoryProject.propTypes = {
    clickSubmitHandler: PropTypes.func.isRequired,
    projectList: PropTypes.array,
    title: PropTypes.string,
    opportunity: PropTypes.string,
    username: PropTypes.string,
    reponame: PropTypes.string,
    srclang: PropTypes.string,
    tgtlang: PropTypes.string,
    gitlabProjects: PropTypes.func.isRequired,
    gitlab_id: PropTypes.string,
    groupId: PropTypes.string,
    filesList: PropTypes.array
  };
  
  export default injectIntl(CreateDataFactoryProject);


// WEBPACK FOOTER //
// ./src/components/views/CreateDataFactoryProject/index.js